import { aiStudioPalette, colors } from '@guryou/colors';

import { spacer } from '../constants';

const formOverrides = formControlSize => ({
  MuiFormControl: {
    root: {
      width: '100%',
      display: 'flex',
      margin: 0,
      maxWidth: formControlSize,
      whiteSpace: 'nowrap',
      '& label.Mui-focused': {
        color: colors.mandy,
        fontWeight: 500,
      },
      '&.paymentForm': {
        maxWidth: '100%',
      },
      '&.serieAutocomplete': {
        maxWidth: '100%',
      },
      '& .myWorkoutCheckBox': {
        padding: '5px 5px',
      },
    },
    fullWidth: {
      maxWidth: 'unset',
    },
    marginNormal: {
      width: `calc(100% - ${2 * spacer.spacer3}px)`,
      margin: spacer.spacer3,
      marginBottom: spacer.spacer2,
    },
  },
  MuiInput: {
    underline: {
      marginTop: 0,
      '&:after': {
        borderBottomColor: colors.mineShaft,
      },
    },
    input: {
      '&[type="color"]': {
        width: '40%',
        marginLeft: 'auto',
        padding: 0,
        height: spacer.spacer4,
      },
    },
  },
  MuiOutlinedInput: {
    root: {
      '&.Mui-focused fieldset': {
        borderColor: colors.mineShaft,
      },
      // AI Studio 2 input skin (8px radius, paper background, coral focus) —
      // applied via InputProps={{ className: 'studio-input' }} on TextBox/SearchBox.
      '&.studio-input': {
        minHeight: 36,
        boxSizing: 'border-box',
        borderRadius: 8,
        backgroundColor: aiStudioPalette.white,
        fontSize: 13.5,
        color: aiStudioPalette.ink,
        '& fieldset': {
          borderColor: aiStudioPalette.border2,
        },
        '&:hover fieldset': {
          borderColor: aiStudioPalette.border2,
        },
        '&.Mui-focused': {
          backgroundColor: aiStudioPalette.white,
        },
        '&.Mui-focused fieldset': {
          borderColor: aiStudioPalette.coral,
          borderWidth: 1,
        },
        '& .MuiOutlinedInput-input': {
          padding: '8px 11px',
          height: 'auto',
        },
        '&.MuiOutlinedInput-multiline': {
          padding: 0,
        },
        '& .MuiOutlinedInput-inputMultiline': {
          padding: '10px 11px',
          lineHeight: 1.45,
        },
      },
    },
    input: {
      padding: '12px 8px',
    },
  },
  MuiInputLabel: {
    shrink: {
      '&+.MuiInput-formControl input[type="color"]': {
        width: '100%',
      },
    },
    outlined: {
      top: '-6px',
      '&$shrink': {
        top: '0',
      },
    },
  },

  MuiFormHelperText: {
    contained: {
      marginLeft: 0,
      marginRight: 0,
    },
  },

  MuiInputAdornment: {
    root: {
      maxHeight: '100%',
      '& .MuiIconButton-root': {
        padding: 0,
        position: 'absolute',
        right: 0,
      },
    },
  },

  MuiRadio: {
    colorPrimary: {
      '&.Mui-checked': {
        color: colors.mineShaft,
      },
    },
  },
  MuiCheckbox: {
    colorPrimary: {
      '&.Mui-checked': {
        color: colors.amber,
      },
    },
  },

  MuiFormControlLabel: {
    root: {
      '&.profileAgreements': {
        whiteSpace: 'pre-wrap',
      },
    },
  },
});

export { formOverrides };
